import { useUpdate } from 'react-admin';
import { useGetAppConfig } from './useGetAppConfig';
import { useOnSettled } from './useOnSettled';
import { useCallback } from 'react';
import {
  Box,
  CircularProgress,
  Switch,
  Tooltip,
  IconButton,
  Typography,
} from '@mui/material';
import { Semaphore } from './Semaphore';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

export const MagicEdit = () => {
  const [updateConfig, { isLoading: isUpdating }] = useUpdate(
    'therapistAppConfig',
    { id: 'current' },
  );

  const {
    remoteAppConfig,
    refetchAppConfig,
  } = useGetAppConfig();
  const ff_magicEdit = remoteAppConfig?.ff_magicEdit;

  const { onSettled: doSettled } = useOnSettled();

  const onSettled = useCallback(async () => {
    doSettled();
    await refetchAppConfig();
  }, [doSettled, refetchAppConfig]);

  const onSwitch = useCallback(async () => {
    await updateConfig(
      'therapistAppConfig',
      {
        id: 'current',
        data: {
          ff_magicEdit: ff_magicEdit ? 0 : 1,
        },
      },
      {
        onSettled,
      },
    );
  }, [updateConfig, onSettled, ff_magicEdit]);

  return (
    <Box marginTop="2rem">
      <Box
        display="flex"
        alignItems="center"
        gap={0.5}
        marginBottom={1}
      >
        <Typography variant="h6">
          Magic Edit
        </Typography>
        <Tooltip title="When enabled globally, therapists can use AI to edit session notes via instructions. Can be overridden per therapist in therapist edit.">
          <IconButton size="small" sx={{ padding: 0.5 }}>
            <HelpOutlineIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        gap={1}
      >
        <Box display="flex" alignItems="center" gap={0.5}>
          <Switch
            checked={!!ff_magicEdit}
            onChange={onSwitch}
            disabled={isUpdating}
          />
        </Box>
        <Box
          marginLeft="1rem"
          display="flex"
          flexDirection="row"
          alignItems="center"
        >
          {isUpdating && <CircularProgress size={14} />}
          {!isUpdating && (
            <Semaphore enabled={!!ff_magicEdit} />
          )}
        </Box>
      </Box>
    </Box>
  );
};
